// 29cfc9
export const siteColor = 'teal';
export const fadeColor = '#00808042';
export const emptyObj = {};